import api from '@/api'
import * as types from '../mutation-types'

// initial state
const state = {
  all: [],
  randomThree: [],
  artikel: {}
}

// getters
const getters = {
  allArtikel: state => state,
}

// actions
const actions = {
  getAllArtikel({ commit }) {
    api.get('/v1/berita')
      .then(response => {
        let responseData = response.data
        commit(types.BERITA_RECIEVE, { responseData })
      })
      .catch(e => {
        // FIXME: Tell our user when we got some errors
        console.log(e)
      })
  },
  getOneArtikel({ commit }, id) {
    api.get(`/v1/berita/${id}`)
      .then(response => {
        let responseData = response.data
        commit(types.ONE_BERITA_RECEIVE, { responseData })
      })
      .catch(e => {
        // FIXME: Tell our user when we got some errors
        console.log(e)
      })
  }
}

// mutations
const mutations = {
  [types.BERITA_RECIEVE](state, { responseData }) {
    state.all = responseData.data
    state.randomThree = [
      state.all.length > 0 ? state.all[0] : null,
      state.all.length > 1 ? state.all[1] : null,
      state.all.length > 2 ? state.all[2] : null
    ]
  },
  [types.ONE_BERITA_RECEIVE](state, {responseData}) {
    state.artikel = responseData.data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/artikel.js